module.exports = __webpack_public_path__ + "static/media/edit.f2fdab98.svg";